import request from '@/utils/request'
import serialize from '@/utils/serialize'
import axios from 'axios'
const CancelToken = axios.CancelToken

// Get all race challenges
export function getRaceChallenges(params) {
  return request({
    url: '/race-challenge' + serialize(params),
    method: 'get'
  })
}

// Get a specific race challenge
export function getRaceChallenge(id, classUid) {
  return request({
    url: `/race-challenge/${id}/detail?classUid=${classUid}`,
    method: 'get'
  })
}

// Create a new race challenge
export function createRaceChallenge(data) {
  return request({
    url: '/race-challenge',
    method: 'post',
    data
  })
}

// Update a race challenge
export function updateRaceChallenge(id, data) {
  return request({
    url: `/race-challenge/${id}`,
    method: 'put',
    data
  })
}

// Upload thumbnailUrl
export function uploadThumbnail(data, handleProgress, cancel) {
  const upload = new FormData()
  upload.append('file', data.file)

  return request({
    url:
      '/race-challenge/file/upload' +
      serialize({
        classId: data.classId
      }),
    method: 'put',
    timeout: false,
    data: upload,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: handleProgress,
    cancelToken: new CancelToken(function executor(c) {
      if (cancel) {
        cancel(c)
      }
    })
  })
}

// Delete a race challenge
export function deleteRaceChallenge(id) {
  return request({
    url: `/race-challenge/${id}`,
    method: 'delete'
  })
}

// Create team
export function createTeam(id, data) {
  return request({
    url: `/race-challenge/${id}/teams`,
    method: 'post',
    data
  })
}

// Update team
export function updateTeam(id, teamId, data) {
  return request({
    url: `/race-challenge/${id}/teams/${teamId}`,
    method: 'put',
    data
  })
}

// Delete team
export function deleteTeam(id, teamId) {
  return request({
    url: `/race-challenge/${id}/teams/${teamId}`,
    method: 'delete'
  })
}

// Get list of teams
export function getTeams(id) {
  return request({
    url: `/race-challenge/${id}/teams`,
    method: 'get'
  })
}

// Get team members
export function getTeamMembers(id, teamId) {
  return request({
    url: `/race-challenge/${id}/teams/${teamId}/members`,
    method: 'get'
  })
}

// Start a race challenge
export function startRaceChallenge(id) {
  return request({
    url: `/race-challenge/${id}/start`,
    method: 'post'
  })
}

// Get team rankings for a race challenge
export function getTeamRankings(id) {
  return request({
    url: `/race-challenge/${id}/ranking/team`,
    method: 'get'
  })
}

// Get member rankings
export function getPersonalRankings(id) {
  return request({
    url: `/race-challenge/${id}/ranking/personal`,
    method: 'get'
  })
}

// Create a mission
export function createMission(raceChallengeId, data) {
  return request({
    url: `/race-challenge/${raceChallengeId}/missions`,
    method: 'post',
    data
  })
}

// Get all missions for a race challenge
export function getMissions(raceChallengeId) {
  return request({
    url: `/race-challenge/${raceChallengeId}/missions`,
    method: 'get'
  })
}

// Sort missions
export function sortMissions(raceChallengeId, data) {
  return request({
    url: `/race-challenge/${raceChallengeId}/missions/sort-order`,
    method: 'put',
    data
  })
}

// Upload thumbnailUrl
export function uploadMissionFile(data, handleProgress, cancel) {
  const upload = new FormData()
  upload.append('file', data.file)

  return request({
    url: `/race-challenge/${data.raceChallengeId}/missions/photos/upload`,
    method: 'put',
    timeout: false,
    data: upload,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: handleProgress,
    cancelToken: new CancelToken(function executor(c) {
      if (cancel) {
        cancel(c)
      }
    })
  })
}

// Update a mission
export function updateMission(raceChallengeId, missionId, data) {
  return request({
    url: `/race-challenge/${raceChallengeId}/missions/${missionId}`,
    method: 'put',
    data
  })
}

// Delete a mission
export function deleteMission(raceChallengeId, missionId) {
  return request({
    url: `/race-challenge/${raceChallengeId}/missions/${missionId}`,
    method: 'delete'
  })
}

// Review a photo mission submission
export function reviewPhotoMission(raceChallengeId, data) {
  return request({
    url: `/race-challenge/${raceChallengeId}/missions/review`,
    method: 'post',
    data
  })
}

export function listReviewPhotos(raceChallengeId) {
  return request({
    url: `/race-challenge/${raceChallengeId}/missions/review-photos`,
    method: 'get'
  })
}

export function listQuestion(raceChallengeId, missionId) {
  return request({
    url: `/race-challenge/${raceChallengeId}/questions?missionId=${missionId}`,
    method: 'get'
  })
}

// Create a question for a question-type mission
export function createQuestion(raceChallengeId, data) {
  return request({
    url: `/race-challenge/${raceChallengeId}/questions`,
    method: 'post',
    data
  })
}

// Bulk create questions for a question-type mission
export function bulkCreateQuestions(raceChallengeId, data) {
  return request({
    url: `/race-challenge/${raceChallengeId}/questions/bulk`,
    method: 'post',
    data
  })
}

// Update a question
export function updateQuestion(raceChallengeId, data) {
  return request({
    url: `/race-challenge/${raceChallengeId}/questions`,
    method: 'put',
    data
  })
}

// Delete a question
export function deleteQuestion(raceChallengeId, data) {
  return request({
    url: `/race-challenge/${raceChallengeId}/questions`,
    method: 'delete',
    data
  })
}

// Upload question attachment
export function uploadQuestionAttachment(data, handleProgress, cancel) {
  const upload = new FormData()
  upload.append('file', data.file)

  return request({
    url: `/race-challenge/${data.raceChallengeId}/questions/upload`,
    method: 'put',
    timeout: false,
    data: upload,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: handleProgress,
    cancelToken: new CancelToken(function executor(c) {
      if (cancel) {
        cancel(c)
      }
    })
  })
}

// Get users locations
export function getUserLocations(raceChallengeId) {
  return request({
    url: `/race-challenge/${raceChallengeId}/locations`,
    method: 'get'
  })
}
